(function (root, factory) {
  if (typeof module === 'object' && module.exports) module.exports = factory;
  else {
    if (root.StellarCartSafety) return;
    const raw = root.fetch.bind(root);
    const path = root.Shopify?.routes?.root || '/';
    const storage = {
      get: () => { try { return JSON.parse(root.localStorage.getItem('stellar-service-cleanup-v1') || 'null'); } catch (_) { return null; } },
      set: value => { try { root.localStorage.setItem('stellar-service-cleanup-v1', JSON.stringify(value)); } catch (_) { if (value.records.length) throw Error('service_cleanup_storage'); } }
    };
    const api = factory(raw, path, operation => navigator.locks ? navigator.locks.request('stellar-cart-mutation', operation) : operation(), storage);
    root.StellarCartSafety = api;
    root.fetch = api.fetch;
    let passing = false;
    const check = async resume => {
      if (passing) return;
      try {
        const result = await api.run(async () => {
          const before = await api.read();
          return api.reconcile(before, before);
        });
        if (result.changed) { location.assign(path + 'cart'); return; }
        passing = true; resume();
        setTimeout(() => { passing = false; }, 0);
      } catch (_) {
        const error = document.getElementById('cart-errors') || document.getElementById('CartDrawer-CartErrors');
        if (error) error.textContent = root.cartStrings?.error || 'Please review your bag before checkout.';
      }
    };
    document.addEventListener('click', event => {
      if (passing || event.defaultPrevented || event.button > 0 || event.ctrlKey || event.metaKey) return;
      const link = event.target.closest?.('a[href]');
      if (!link) return;
      const url = new URL(link.href, location.href);
      if (url.origin !== location.origin || !/\/checkout\/?$/.test(url.pathname)) return;
      event.preventDefault(); event.stopImmediatePropagation(); check(() => location.assign(url.href));
    }, true);
    document.addEventListener('submit', event => {
      if (passing || event.defaultPrevented) return;
      const form = event.target;
      if (!(form instanceof HTMLFormElement)) return;
      const action = new URL(form.action, location.href);
      if (action.origin !== location.origin || !/\/cart\/?$/.test(action.pathname) || event.submitter?.name !== 'checkout') return;
      event.preventDefault(); event.stopImmediatePropagation();
      check(() => form.requestSubmit(event.submitter));
    }, true);
  }
})(typeof window !== 'undefined' ? window : this, function (raw, root, crossTabLock, storage) {
  'use strict';
  storage = storage || {};
  const path = /^\/(?!\/)[^?#]*\/$/.test(root) ? root : '/';
  let queue = Promise.resolve();
  const knownLines = new Map();
  const keyAliases = new Map();
  const lineIdentity = line => JSON.stringify([String(line.variant_id || line.id), Object.entries(line.properties || {}).sort(([a],[b]) => a.localeCompare(b)), line.selling_plan_allocation?.selling_plan?.id || null, line.parent_relationship?.parent_key || null]);
  const managed = line => !!line.properties?._stellar_gift_parent;
  const parents = new Set(['15393200243001','15393401012537','15393407992121','15393510687033','15393519894841','15393533165881','15393550401849','15393568784697','15393591689529','15393615872313','15393643168057']);
  const id = line => String(line.variant_id || line.id);
  const personalisation = line => id(line) === '49241299779897';
  const personalUnits = cart => cart.items.filter(line => !personalisation(line) && typeof line.properties?.Personalisation === 'string' && line.properties.Personalisation.trim()).reduce((sum, line) => sum + line.quantity, 0);
  // Verified service variants; never infer an add-on's parent from its SKU or name.
  const serviceProperties = new Map([['49241299779897', 'Personalisation'], ['49324708823353', 'Gift Wrapping'], ['49325141557561', 'Gift Wrapping']]);
  const serviceProperty = line => serviceProperties.get(id(line));
  const cleanupMarker = '_stellar_service_cleanup';
  const pendingServices = new Map();
  const fingerprints = new Map();
  const childFingerprints = new Map();
  let storageToken;
  const saveServices = () => storage.set?.({token: storageToken, records: [...pendingServices.values()]});
  const fingerprint = async line => {
    const digest = await crypto.subtle.digest('SHA-256', new TextEncoder().encode(String(storageToken || '') + lineIdentity(line)));
    return [...new Uint8Array(digest)].map(value => value.toString(16).padStart(2, '0')).join('');
  };
  const childCounts = (cart, parentKey) => {
    const counts = new Map();
    for (const line of cart.items.filter(item => item.parent_relationship?.parent_key === parentKey)) {
      const identity = childFingerprints.get(line.key);
      counts.set(identity, (counts.get(identity) || 0) + line.quantity);
    }
    return JSON.stringify([...counts].sort(([a],[b]) => a.localeCompare(b)));
  };
  function rebaseKnownLines(originalKey, originalIdentity, parent) {
    if (!originalIdentity) return;
    for (const [key, identity] of knownLines) {
      if (key === originalKey || keyAliases.get(key) === originalKey) {
        knownLines.set(key, lineIdentity(parent));
        keyAliases.set(key, parent.key);
      }
      else {
        const parts = JSON.parse(identity);
        if (parts[3] === originalKey) { parts[3] = parent.key; knownLines.set(key, JSON.stringify(parts)); }
      }
    }
  }
  function verifyPendingReadbacks(cart) {
    for (const record of pendingServices.values()) {
      if (!record.expectedFingerprint) continue;
      const matches = cart.items.filter(line => line.properties?.[cleanupMarker] === record.marker);
      if (!matches.length) continue;
      const parent = matches[0], actual = fingerprints.get(parent.key);
      if (matches.length === 1 && actual === record.fingerprint && parent.quantity === record.expectedQuantity) continue; // Not committed.
      if (matches.length !== 1 || actual !== record.expectedFingerprint || parent.quantity !== record.expectedQuantity) record.blocked = 'service_property_readback';
      else if (childCounts(cart, parent.key) !== record.expectedChildren) record.blocked = 'service_child_readback';
      else {
        rebaseKnownLines(record.parentKey, knownLines.get(record.parentKey), parent);
        delete record.blocked;
      }
    }
    if (pendingServices.size) saveServices();
  }
  const needsReconciliation = line => managed(line) || !!serviceProperty(line);
  const signature = line => id(line) + ':' + String(line.properties?._stellar_gift_link || '') + ':' + String(line.properties?._stellar_gift_parent || '');
  const parentCount = (cart, gift) => cart.items.filter(line => !managed(line) && id(line) === gift.properties._stellar_gift_parent && line.properties?._stellar_gift_link === gift.properties._stellar_gift_link).reduce((sum,line) => sum + line.quantity, 0);
  function run(operation) {
    const next = queue.then(() => crossTabLock(operation));
    queue = next.catch(() => {});
    return next;
  }
  async function read() {
    const response = await raw(path + 'cart.js', { credentials:'same-origin', cache:'no-store', headers:{Accept:'application/json'} });
    if (!response.ok) throw Error('cart_read');
    return observeCart(await response.json());
  }
  // Full change/update responses are fresh server cart snapshots, not optimistic
  // state. Feed them through exactly the same identity/storage/readback checks.
  async function observeCart(cart) {
    if (!Array.isArray(cart.items) || !cart.currency) throw Error('cart_read');
    const saved = storage.get?.();
    if (storageToken !== undefined && storageToken !== cart.token) { knownLines.clear(); keyAliases.clear(); }
    if (storageToken !== cart.token || storage.get) pendingServices.clear();
    storageToken = cart.token;
    if (saved?.token === cart.token && Array.isArray(saved.records)) {
      for (const record of saved.records) {
        if (typeof record.parentKey === 'string' && typeof record.marker === 'string' && /^\d+$/.test(record.variant) && Array.isArray(record.properties) && record.properties.every(key => key === 'Personalisation' || key === 'Gift Wrapping')) pendingServices.set(record.marker, record);
      }
    }
    fingerprints.clear(); childFingerprints.clear();
    await Promise.all(cart.items.map(async line => {
      fingerprints.set(line.key, await fingerprint(line));
      if (line.parent_relationship?.parent_key) childFingerprints.set(line.key, await fingerprint({...line, parent_relationship: null}));
    }));
    for (const line of cart.items) if (line.key) {
      // A formerly historical key can be reused by a newly added line.
      keyAliases.delete(line.key);
      knownLines.set(line.key, lineIdentity(line));
    }
    verifyPendingReadbacks(cart);
    while (knownLines.size > 500) { const key = knownLines.keys().next().value; knownLines.delete(key); keyAliases.delete(key); }
    return cart;
  }
  function completeCart(cart, before) {
    if (!cart || cart.errors || cart.error || cart.status || typeof cart.token !== 'string' || !cart.token || cart.token !== before.token || typeof cart.currency !== 'string' || !/^[A-Z]{3}$/.test(cart.currency) || cart.currency !== before.currency || !Array.isArray(cart.items) || !Number.isSafeInteger(cart.item_count)) return false;
    const keys = new Set();
    let quantity = 0;
    for (const line of cart.items) {
      if (!line || typeof line.key !== 'string' || !line.key || keys.has(line.key) || !/^\d+$/.test(String(line.variant_id || line.id)) || !Number.isSafeInteger(line.quantity) || line.quantity < 1 || !Object.hasOwn(line, 'properties') || (line.properties !== null && (typeof line.properties !== 'object' || Array.isArray(line.properties))) || !Number.isFinite(line.final_price) || !Number.isFinite(line.final_line_price)) return false;
      keys.add(line.key); quantity += line.quantity;
    }
    if (quantity !== cart.item_count) return false;
    for (const line of cart.items) {
      const parentKey = line.parent_relationship?.parent_key;
      const plan = line.selling_plan_allocation?.selling_plan?.id;
      if (line.selling_plan_allocation != null && (typeof line.selling_plan_allocation !== 'object' || Array.isArray(line.selling_plan_allocation) || !/^[1-9]\d*$/.test(String(plan)))) return false;
      // A known planned line must not silently become unplanned because a partial
      // response omitted its allocation. Exact known unplanned siblings are safe.
      if (!plan && before.items.some(previous => previous.selling_plan_allocation?.selling_plan?.id && id(previous) === id(line)) && !before.items.some(previous => previous.key === line.key && !previous.selling_plan_allocation?.selling_plan?.id)) return false;
      const parent = cart.items.find(item => item.key === parentKey);
      if (line.parent_relationship && (typeof parentKey !== 'string' || !parent || parentKey === line.key || parent.parent_relationship?.parent_key)) return false;
      const previousParentKey = before.items.find(previous => previous.key === line.key)?.parent_relationship?.parent_key;
      // Native links are immutable. A retained child cannot move to a different
      // parent while its original parent still exists under the same key.
      if (previousParentKey && parentKey && previousParentKey !== parentKey && keys.has(previousParentKey)) return false;
      // An incomplete payload must not make a surviving native child look like
      // an unlinked service. Re-read if its relationship metadata is missing.
      if (!parentKey && before.items.some(previous => previous.parent_relationship?.parent_key && id(previous) === id(line)) && !before.items.some(previous => previous.key === line.key && !previous.parent_relationship?.parent_key)) return false;
    }
    return true;
  }
  async function afterMutation(response, before, fullCartEndpoint) {
    let cart;
    if (fullCartEndpoint && response.ok) {
      try { cart = await response.clone().json(); } catch (_) {}
      if (completeCart(cart, before)) return observeCart(cart);
    }
    return read();
  }
  function rememberService(parent, property, originalKey) {
    const fingerprint = fingerprints.get(parent.key);
    const existing = [...pendingServices.values()].find(record => record.parentKey === parent.key || (originalKey && record.parentKey === originalKey) || record.marker === parent.properties[cleanupMarker]);
    // Shopify can reuse an old line key when the same product/options are added
    // again. A fresh opaque marker must not collide with a previously cleaned line.
    const marker = existing?.marker || parent.properties[cleanupMarker] || crypto.randomUUID();
    const record = existing || {parentKey: parent.key, marker, variant: id(parent), fingerprint, properties: []};
    record.parentKey = parent.key;
    if (!record.properties.includes(property)) record.properties.push(property);
    pendingServices.set(marker, record);
  }
  function rememberRequestedServices(cart, request) {
    for (const service of cart.items) {
      const property = serviceProperty(service), parentKey = service.parent_relationship?.parent_key;
      const quantity = request.id === service.key ? request.quantity : request.updates?.[service.key];
      if (!property || !parentKey || quantity === undefined || Number(quantity) !== 0) continue;
      const parent = cart.items.find(line => line.key === parentKey);
      if (parent && Object.hasOwn(parent.properties || {}, property)) rememberService(parent, property);
    }
    for (const record of pendingServices.values()) {
      const parent = cart.items.find(line => line.key === record.parentKey || line.properties?.[cleanupMarker] === record.marker);
      const quantity = parent && (request.id === parent.key ? request.quantity : request.updates?.[parent.key]);
      if (parent && quantity !== undefined && Number(quantity) === 0) record.removing = true;
    }
    // Persist before the destructive request: other tabs and reloads can then
    // finish or cancel this exact intent after reading Shopify's actual state.
    saveServices();
  }
  function findParent(before, cart, original) {
    const exact = cart.items.find(line => line.key === original.key);
    if (exact) return exact;
    const identity = knownLines.get(original.key) || lineIdentity(original);
    // A different pre-existing discount split is not proof that a removed parent
    // changed keys. Leave ambiguous legacy/split associations untouched.
    if (before.items.filter(line => lineIdentity(line) === lineIdentity(original)).length !== 1) return;
    const matches = cart.items.filter(line => lineIdentity(line) === identity);
    if (matches.length > 1) throw Error('service_parent_identity');
    if (matches.length === 1) rebaseKnownLines(original.key, identity, matches[0]);
    return matches[0];
  }
  function serviceTargets(before, after) {
    // A pre-mutation native relationship is the evidence for each cleanup intent.
    // Legacy unlinked/shared services deliberately cannot enter this path.
    for (const service of before.items) {
      const property = serviceProperty(service), parentKey = service.parent_relationship?.parent_key;
      if (!property || !parentKey) continue;
      const original = before.items.find(line => line.key === parentKey);
      if (!original || !Object.hasOwn(original.properties || {}, property)) continue;
      const parent = findParent(before, after, original);
      if (!parent || !Object.hasOwn(parent.properties || {}, property)) continue;
      if (after.items.some(line => serviceProperty(line) === property && line.parent_relationship?.parent_key === parent.key && line.quantity > 0)) continue;
      if (parent.properties[property] !== original.properties[property]) throw Error('service_property_changed');
      rememberService(parent, property, original.key);
    }
    const changes = [];
    for (const [marker, record] of pendingServices) {
      let matches = after.items.filter(line => line.key === record.parentKey || line.properties?.[cleanupMarker] === marker);
      if (!matches.length && record.removing) { pendingServices.delete(marker); continue; }
      if (!matches.length && record.fingerprint) matches = after.items.filter(line => fingerprints.get(line.key) === record.fingerprint);
      if (!matches.length && knownLines.has(record.parentKey)) matches = after.items.filter(line => lineIdentity(line) === knownLines.get(record.parentKey));
      if (matches.length !== 1) {
        if (!matches.length && (record.removing || !after.items.some(line => id(line) === record.variant))) { pendingServices.delete(marker); continue; }
        throw Error('service_parent_identity');
      }
      const parent = matches[0];
      record.parentKey = parent.key;
      if (record.blocked) throw Error(record.blocked);
      record.properties = record.properties.filter(property => Object.hasOwn(parent.properties || {}, property) && !after.items.some(line => serviceProperty(line) === property && line.parent_relationship?.parent_key === parent.key && line.quantity > 0));
      if (!record.properties.length) { pendingServices.delete(marker); continue; }
      const properties = {...parent.properties};
      for (const property of record.properties) delete properties[property];
      // Keep this exact line distinct when its visible options become identical to
      // another product. Also avoids Shopify's unsupported empty-properties update.
      properties[cleanupMarker] = marker;
      changes.push({id: parent.key, quantity: parent.quantity, properties});
    }
    saveServices();
    return changes;
  }
  function rebaseServiceKeys(previous, cart, change, uncertain = false) {
    if (!change.properties?.[cleanupMarker]) return;
    const original = previous.items.find(line => line.key === change.id);
    const expected = {...original, properties: change.properties};
    const matches = cart.items.filter(line => lineIdentity(line) === lineIdentity(expected));
    const fail = message => {
      const record = pendingServices.get(change.properties[cleanupMarker]);
      if (record) { record.blocked = message; saveServices(); }
      throw Error(message);
    };
    if (matches.length !== 1 || matches[0].quantity !== original.quantity) {
      if (uncertain && cart.items.some(line => lineIdentity(line) === lineIdentity(original) && line.quantity === original.quantity)) throw Error('service_property_uncommitted');
      fail('service_property_readback');
    }
    const parent = matches[0], originalIdentity = lineIdentity(original);
    // Property edits change parent keys, and Shopify consequently changes child keys.
    // Rebase only identities proven by this exact update, not all lines of a variant.
    rebaseKnownLines(original.key, originalIdentity, parent);
    const children = (items, key) => {
      const counts = new Map();
      for (const line of items.filter(item => item.parent_relationship?.parent_key === key)) {
        const identity = lineIdentity({...line, parent_relationship: null});
        counts.set(identity, (counts.get(identity) || 0) + line.quantity);
      }
      return JSON.stringify([...counts].sort(([a],[b]) => a.localeCompare(b)));
    };
    if (children(previous.items, original.key) !== children(cart.items, parent.key)) fail('service_child_readback');
  }
  function targets(before, after, manualGiftKeys = new Set()) {
    const changes = serviceTargets(before, after);
    const seen = new Set(), groups = new Map();
    for (const gift of after.items.filter(managed)) {
      const p = gift.properties, units = Number(p._stellar_gift_units), identity = signature(gift);
      if (!gift.key || !p._stellar_gift_link || !parents.has(p._stellar_gift_parent_product) || !/^\d+$/.test(p._stellar_gift_parent) || !Number.isSafeInteger(units) || units < 1 || units > 999 || !Number.isSafeInteger(gift.quantity) || gift.quantity < 1 || seen.has(gift.key)) throw Error('gift_identity');
      seen.add(gift.key);
      const group = groups.get(identity) || [];
      if (group.some(line => line.properties._stellar_gift_parent_product !== p._stellar_gift_parent_product || line.properties._stellar_gift_units !== p._stellar_gift_units)) throw Error('gift_identity');
      group.push(gift); groups.set(identity, group);
    }
    for (const [identity, group] of groups) {
      const gift = group[0], units = Number(gift.properties._stellar_gift_units);
      const previous = before.items.filter(line => managed(line) && signature(line) === identity);
      const previousQuantity = previous.reduce((sum,line) => sum + line.quantity, 0);
      const currentQuantity = group.reduce((sum,line) => sum + line.quantity, 0);
      const eligible = parentCount(after, gift) * units;
      let desired = Math.min(currentQuantity, eligible);
      if (previous.length && !previous.some(line => manualGiftKeys.has(line.key)) && previousQuantity === parentCount(before, gift) * units && eligible > previousQuantity) desired = eligible;
      if (manualGiftKeys.has('remove:' + identity)) desired = 0;
      if (!Number.isSafeInteger(desired) || desired < 0 || desired > 999) throw Error('gift_quantity');
      // Shopify splits a discounted gift from its charged surplus, changing keys.
      // Reduce the linked group, charged lines first; never touch untagged paid items.
      let excess = currentQuantity - desired;
      const ordered = [...group].sort((a,b) => b.final_line_price - a.final_line_price);
      for (const line of ordered) {
        if (excess <= 0) break;
        const remove = Math.min(line.quantity, excess);
        changes.push({id:line.key,quantity:line.quantity-remove}); excess -= remove;
      }
      if (currentQuantity > desired) continue;
      const charged = group.filter(line => line.final_price !== 0 || line.final_line_price !== 0);
      if (charged.length) { charged.forEach(line => changes.push({id:line.key,quantity:0})); continue; }
      if (desired > currentQuantity) changes.push({id:gift.key,quantity:gift.quantity+desired-currentQuantity});
    }
    if (personalUnits(before) > 0) {
      const legacy = after.items.filter(line => personalisation(line) && !line.parent_relationship?.parent_key);
      const nestedUnits = after.items.filter(line => personalisation(line) && line.parent_relationship?.parent_key).reduce((sum, line) => sum + line.quantity, 0);
      let remaining = Math.max(0, personalUnits(after) - nestedUnits);
      for (const line of legacy) {
        const desired = Math.min(line.quantity, remaining);
        remaining -= desired;
        if (desired !== line.quantity) {
          if (!line.key) throw Error('personalisation_identity');
          changes.push({id: line.key, quantity: desired});
        }
      }
    }
    return changes;
  }
  async function reconcile(before, cart, manualGiftKeys) {
    let changed = false;
    for (let attempt=0;attempt<64;attempt++) {
      if (cart.currency !== before.currency) throw Error('cart_currency');
      const todo = targets(before, cart, manualGiftKeys);
      if (!todo.length) return {cart,changed};
      changed = true;
      const previous = cart;
      if (todo[0].properties?.[cleanupMarker]) {
        const original = cart.items.find(line => line.key === todo[0].id);
        const record = pendingServices.get(todo[0].properties[cleanupMarker]);
        record.parentKey = original.key;
        record.fingerprint = fingerprints.get(original.key);
        record.expectedFingerprint = await fingerprint({...original, properties: todo[0].properties});
        record.expectedQuantity = original.quantity;
        record.expectedChildren = childCounts(cart, original.key);
        saveServices();
      }
      let response;
      try {
        response = await raw(path + 'cart/change.js', {method:'POST',credentials:'same-origin',headers:{'Content-Type':'application/json',Accept:'application/json'},body:JSON.stringify(todo[0])});
      } catch (error) {
        // A lost response may follow a committed property edit. Verify the exact
        // marker/properties/children and rebase keys before deciding to retry.
        cart = await read();
        if (!todo[0].properties) throw error;
        try { rebaseServiceKeys(previous, cart, todo[0], true); } catch (_) { throw error; }
        continue;
      }
      cart = await afterMutation(response, previous, true);
      if (!response.ok) throw Error('gift_change');
      rebaseServiceKeys(previous, cart, todo[0]);
    }
    throw Error('gift_reconciliation');
  }
  function decode(body) {
    if (typeof body === 'string') { try { return JSON.parse(body); } catch (_) { return Object.fromEntries(new URLSearchParams(body)); } }
    if (body && typeof body.entries === 'function') return Object.fromEntries(body.entries());
    return {};
  }
  async function wrapped(input, init={}) {
    const url = new URL(typeof input === 'string' ? input : input.url, typeof location === 'undefined' ? 'https://stellarhair.com.au' : location.href);
    const origin = typeof location === 'undefined' ? 'https://stellarhair.com.au' : location.origin;
    if (url.origin !== origin || !/\/cart\/(add|change|update|clear)(\.js)?\/?$/.test(url.pathname) || String(init.method || input.method || 'GET').toUpperCase() !== 'POST') return raw(input,init);
    const request = decode(init.body === undefined && typeof input?.clone === 'function' ? await input.clone().text() : init.body);
    if (request.line) {
      const line = typeof document === 'undefined' ? null : document.getElementById('CartItem-'+request.line) || document.getElementById('CartDrawer-Item-'+request.line);
      const href = line?.querySelector('a[href*="/cart/change?"]')?.getAttribute('href');
      const key = line?.getAttribute('data-cart-line-key') || (href ? new URL(href,origin).searchParams.get('id') : null);
      if (key) { request.id=key; delete request.line; init={...init,body:JSON.stringify(request)}; }
    }
    return run(async () => {
      const before = await read();
      if (request.line && before.items.some(needsReconciliation)) throw Error('cart_line_identity');
      if (Array.isArray(request.updates) && before.items.some(needsReconciliation)) throw Error('cart_line_identity');
      // A queued UI request may contain a key invalidated by discount splitting.
      // Resolve only the exact variant/properties identity observed on an earlier read.
      if (request.id && !before.items.some(line => line.key === request.id)) {
        const identity = knownLines.get(request.id);
        const matches = identity ? before.items.filter(line => lineIdentity(line) === identity) : [];
        if (matches.length === 1 || (Number(request.quantity) === 0 && matches.length && matches.every(managed))) {
          if (matches.length === 1) rebaseKnownLines(request.id, identity, matches[0]);
          request.id = matches[0].key;
          init = {...init, body:JSON.stringify(request)};
        } else if (identity && !matches.length && Number(request.quantity) === 0) {
          // Already removed by the previous queued action. Return current sections.
          const sectionUrl = new URL(request.sections_url || path + 'cart', origin);
          if (sectionUrl.origin !== origin) throw Error('cart_sections');
          const names = Array.isArray(request.sections) ? request.sections : String(request.sections || '').split(',').filter(Boolean);
          let sections;
          if (names.length) {
            sectionUrl.searchParams.set('sections',names.join(','));
            const response = await raw(sectionUrl.href,{credentials:'same-origin',cache:'no-store'});
            if (!response.ok) throw Error('cart_sections');
            sections = await response.json();
          }
          return new Response(JSON.stringify({...before,...(sections ? {sections} : {})}),{headers:{'Content-Type':'application/json'}});
        } else if (identity) throw Error('cart_line_identity');
      }
      if (request.updates && !Array.isArray(request.updates)) {
        const updates = {};
        for (const [key, quantity] of Object.entries(request.updates)) {
          const identity = knownLines.get(key);
          const exact = before.items.find(line => line.key === key);
          const matches = exact ? [exact] : before.items.filter(line => identity && lineIdentity(line) === identity);
          if (identity && matches.length !== 1) {
            if (!matches.length && Number(quantity) === 0) continue;
            throw Error('cart_line_identity');
          }
          const resolved = matches[0]?.key || key;
          if (!exact && matches.length === 1) rebaseKnownLines(key, identity, matches[0]);
          if (Object.hasOwn(updates, resolved)) throw Error('cart_line_identity');
          updates[resolved] = quantity;
        }
        request.updates = updates;
        init = {...init, body: JSON.stringify(request)};
      }
      const manual = new Set();
      for (const line of before.items.filter(managed)) {
        if (request.id === line.key || request.updates && Object.hasOwn(request.updates,line.key)) {
          for (const sibling of before.items.filter(item => managed(item) && signature(item) === signature(line))) manual.add(sibling.key);
          if (Number(request.id === line.key ? request.quantity : request.updates[line.key]) === 0) manual.add('remove:' + signature(line));
        }
      }
      rememberRequestedServices(before, request);
      let response;
      try { response=await raw(input,init); } catch (error) {
        try { await reconcile(before,await read(),manual); } catch (_) {}
        throw error;
      }
      let after = await afterMutation(response, before, /\/cart\/(change|update)(\.js)?\/?$/.test(url.pathname));
      if (!pendingServices.size && !before.items.some(needsReconciliation) && !after.items.some(needsReconciliation)) return response;
      const settled = await reconcile(before,after,manual);
      if (!settled.changed) return response;
      const original = await response.clone().json();
      const data = {...original,...settled.cart};
      if (original.sections) {
        const sectionUrl = new URL(request.sections_url || path + 'cart', origin);
        if (sectionUrl.origin !== origin) throw Error('cart_sections');
        sectionUrl.searchParams.set('sections',Object.keys(original.sections).join(','));
        const refreshed = await raw(sectionUrl.href,{credentials:'same-origin',cache:'no-store'});
        if (!refreshed.ok) throw Error('cart_sections');
        data.sections = await refreshed.json();
      }
      const headers = new Headers(response.headers); headers.delete('content-length'); headers.set('content-type','application/json');
      return new Response(JSON.stringify(data),{status:response.status,statusText:response.statusText,headers});
    });
  }
  async function transaction(operation) {
    return run(async () => {
      let result;
      try {
        const before = await read();
        result = await operation();
        if (!result.sent) return result;
        const settled = await reconcile(before, await read());
        return settled.changed ? {...result, cart:settled.cart, phase:'review', checkoutAllowed:false} : {...result, cart:settled.cart};
      } catch (_) {
        return {...result, sent:result?.sent !== false, phase:'review', checkoutAllowed:false};
      }
    });
  }
  return {fetch:wrapped,rawFetch:raw,run,read,reconcile,targets,transaction};
});

